<template>
    <div class="data-table-container">
      <div class="table-box">
        <div
          class="table-wrapper"
          :class="{ 'table-border': border }"
          ref="tableWrapper"
          :style="{ height: tableHeight ? tableHeight : '' }"
        >
          <div class="table-head-wrapper" @scroll="handleHeadScroll">
            <table class="table-container" ref="tableContainer" :border="false">
              <colgroup>
                <col
                  v-for="(column, index) in columns"
                  :name="column.prop"
                  :key="index"
                  :width="column.width ? column.width : '100px'"
                />
              </colgroup>
              <thead>
                <tr class="table-row table-header-row borderClass">
                  <th
                    v-for="(column, index) in columns"
                    :key="column.prop"
                    :class="[
                      'table-cell',
                      'head-bg',
                      `text-${column.align}`,
                      border && index !== columns.length - 1
                        ? 'table-border-right'
                        : '',
                    ]"
                    v-show="showHead({ columnIndex: index })"
                    :rowspan="handleHeadMethod({ columnIndex: index }).rowspan"
                    :colspan="handleHeadMethod({ columnIndex: index }).colspan"
                  >
                    <slot
                      :name="`table-column-header-${
                        column.listProp ? column.listProp : column.prop
                      }`"
                      :column="column"
                      >{{ column.label }}</slot
                    >
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div
            :style="{
              height: tableHeight ? `${tableHeight - headHeight}px` : '',
            }"
            class="table-body-wrapper"
            @scroll="handleBodyScroll"
          >
            <table class="table-container" :border="false">
              <colgroup>
                <col
                  v-for="(column, index) in columns"
                  :name="column.prop"
                  :key="index"
                  :width="column.width ? column.width : '100px'"
                />
              </colgroup>
              <tbody>
                <tr
                  v-for="(row, rowIndex) in data"
                  :key="rowIndex"
                  class="table-row borderClass"
                >
                  <td
                    v-for="(column, index) in columns"
                    :key="column.prop"
                    :class="[
                      'table-cell',
                      `text-${column.align}`,
                      border && index !== columns.length - 1
                        ? 'table-border-right'
                        : '',
                    ]"
                    :rowspan="
                      handleSpanMethod({
                        row,
                        column,
                        rowIndex,
                        columnIndex: index,
                      }).rowspan
                    "
                    :colspan="
                      handleSpanMethod({
                        row,
                        column,
                        rowIndex,
                        columnIndex: index,
                      }).colspan
                    "
                    v-show="
                      showSpan({ row, column, rowIndex, columnIndex: index })
                    "
                  >
                    <div v-if="column.render">
                      <div v-html="column.render(row)"></div>
                    </div>
                    <div v-else>
                      <slot
                        :name="`table-column-cell-${
                          column.listProp ? column.listProp : column.prop
                        }`"
                        :row="row"
                      >
                        {{ row[column.listProp ? column.listProp : column.prop] }}
                      </slot>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 左侧浮动表格覆盖 -->
        <div
          class="table-wrapper-left"
          :class="{ 'fixed-shadow': hasShadow, 'table-border': border }"
          v-if="this.isOverflowing && fixedColumns.length > 0"
          :style="{ height: tableHeight ? tableHeight : '' }"
        >
          <div class="table-head-wrapper-fixed">
            <table class="table-container tw-relative" :border="false">
              <!-- 展开收起按钮 -->
              <!-- <div @click="isHiddenGroup = !isHiddenGroup" class="collapse-box">
              <img
                class="tw-w-[13px] tw-h-[13px] collapse-icon"
                :src="
                  isHiddenGroup
                    ? require('@/assets/yhj/icons/icon-arrow-right.png')
                    : require('@/assets/yhj/icons/icon-arrow-left.png')
                "
              />
            </div> -->
              <colgroup>
                <col
                  v-for="(column, index) in fixedColumns"
                  :name="column.prop"
                  :key="index"
                  :width="column.width ? column.width : '100px'"
                />
              </colgroup>
              <thead class="table-head-wrapper">
                <tr class="table-row table-header-row borderClass">
                  <th
                    v-for="(column, index) in fixedColumns"
                    :key="column.prop"
                    :class="[
                      'table-cell',
                      'head-bg',
                      `text-${column.align}`,
                      border && index !== fixedColumns.length - 1
                        ? 'table-border-right'
                        : '',
                    ]"
                    v-show="showHead({ columnIndex: index })"
                    :rowspan="
                      handleHeadMethod({ columnIndex: index }).rowspan || 1
                    "
                    :colspan="
                      handleHeadMethod({ columnIndex: index }).colspan || 1
                    "
                  >
                    <slot
                      :name="`table-column-header-${
                        column.listProp ? column.listProp : column.prop
                      }`"
                      :column="column"
                      >{{ column.label }}</slot
                    >
                  </th>
                </tr>
              </thead>
            </table>
          </div>
  
          <div
            :style="{
              height: tableHeight ? `${tableHeight - headHeight}px` : '',
            }"
            class="table-body-wrapper-fixed"
            @scroll="handleFixedBodyScroll"
          >
            <table :border="false" class="table-container">
              <colgroup>
                <col
                  v-for="(column, index) in fixedColumns"
                  :name="column.prop"
                  :key="index"
                  :width="column.width ? column.width : '100px'"
                />
              </colgroup>
              <tbody>
                <tr
                  v-for="(row, rowIndex) in data"
                  :key="rowIndex"
                  class="table-row borderClass"
                >
                  <td
                    v-for="(column, index) in fixedColumns"
                    :key="column.prop"
                    :class="[
                      'table-cell',
                      `text-${column.align}`,
                      border && index !== fixedColumns.length - 1
                        ? 'table-border-right'
                        : '',
                    ]"
                    :rowspan="
                      handleSpanMethod({
                        row,
                        column,
                        rowIndex,
                        columnIndex: index,
                      }).rowspan || 1
                    "
                    :colspan="
                      handleSpanMethod({
                        row,
                        column,
                        rowIndex,
                        columnIndex: index,
                      }).colspan || 1
                    "
                    v-show="
                      showSpan({ row, column, rowIndex, columnIndex: index })
                    "
                  >
                    <!-- 如果有自己的 render 函数 -->
                    <div v-if="column.render">
                      <div v-html="column.render(row)"></div>
                    </div>
                    <div v-else>
                      <slot
                        :name="`table-column-cell-${
                          column.listProp ? column.listProp : column.prop
                        }`"
                        :row="row"
                      >
                        {{ row[column.listProp ? column.listProp : column.prop] }}
                      </slot>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "DataTable",
    props: {
      tableHeight: {
        type: Number,
        default: 0,
      },
      columns: {
        type: Array,
        required: true,
      },
      data: {
        type: Array,
        required: true,
      },
      totalData: {
        type: Array,
        default: null,
      },
      handleSpanMethod: {
        type: Function,
        default: () => {
          return {
            rowspan: 1,
            colspan: 1,
          };
        },
      },
      handleHeadMethod: {
        type: Function,
        default: () => {
          return {
            rowspan: 1,
            colspan: 1,
          };
        },
      },
      border: {
        type: Boolean,
        default: false,
      },
      hiddenFirstColumn: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isOverflowing: false,
        hasShadow: false,
        showScrollIndicator: true,
        timer: null,
        isHiddenGroup: false,
        headHeight: "",
      };
    },
    watch: {},
    mounted() {
      // this.$nextTick(this.checkOverflow);
      window.addEventListener("resize", this.checkOverflow);
      // TODO: Improvement
      this.timer = setTimeout(() => {
        this.checkOverflow();
        if (this.isOverflowing) {
          clearInterval(this.timer);
        }
      }, 50);
    },
    computed: {
      fixedColumns() {
        return this.columns.filter((column) => column.fixed === "left");
      },
    },
  
    updated() {
      if (this.border && this.tableHeight) {
        this.headHeight = document.querySelector(
          ".table-head-wrapper"
        ).clientHeight;
      }
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.checkOverflow);
    },
    methods: {
      showSpan({ row, column, rowIndex, columnIndex }) {
        if (this.isHiddenGroup && columnIndex == 0) {
          return false;
        }
        let obj = this.handleSpanMethod({ row, column, rowIndex, columnIndex });
        if (obj && obj.rowspan > 0 && obj.colspan > 0) {
          return true;
        } else {
          return false;
        }
      },
      showHead({ columnIndex }) {
        let obj = this.handleHeadMethod({ columnIndex });
        if (obj && obj.rowspan > 0 && obj.colspan > 0) {
          return true;
        } else {
          return false;
        }
      },
      checkOverflow() {
        if (!this.$refs.tableWrapper) return;
        this.$nextTick(() => {
          const tableWrapper = this.$refs.tableWrapper;
          const tableContainer = this.$refs.tableContainer;
          this.isOverflowing =
            tableContainer.scrollWidth > tableWrapper.offsetWidth;
        });
      },
      handleHeadScroll(e) {
        // 头部固定左右滚动给内容设置滚动
        if (e.target) {
          let bodyDom = document.querySelector(".table-body-wrapper");
          if (bodyDom) {
            bodyDom.scrollLeft = e.target.scrollLeft;
          }
          this.hasShadow = e.target.scrollLeft > 0;
        }
      },
      handleBodyScroll(e) {
        // 内容区滚动带着头部一起滚动
        if (e.target) {
          let headDom = document.querySelector(".table-head-wrapper");
          if (headDom) {
            headDom.scrollLeft = e.target.scrollLeft;
          }
          this.hasShadow = e.target.scrollLeft > 0;
          if (this.fixedColumns.length > 0 && this.isOverflowing) {
            let fixedBodyDom = document.querySelector(
              ".table-body-wrapper-fixed"
            );
            if (fixedBodyDom) {
              fixedBodyDom.scrollTop = e.target.scrollTop;
            }
          }
        }
      },
      handleFixedBodyScroll(e) {
        // 左侧固定区滚动带着内容一起滚动
        if (e.target) {
          let bodyDom = document.querySelector(".table-body-wrapper");
          if (bodyDom) {
            bodyDom.scrollTop = e.target.scrollTop;
          }
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .data-table-container {
    width: 100%;
    box-sizing: border-box;
    border-radius: 6px;
    background: #fff;
    position: relative;
  }
  
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    padding-left: 12px;
    padding-right: 12px;
  }
  
  .table-title {
    font-size: 15px;
    color: #212121;
    font-weight: 500;
    margin-bottom: 0;
  }
  .table-box {
    margin-left: 12px;
    padding-right: 12px;
    overflow: hidden;
  }
  
  .table-wrapper::-webkit-scrollbar {
    display: none;
  }
  .table-wrapper-left {
    position: absolute;
    left: 12px;
    top: 0px;
    z-index: 2;
  }
  .table-container {
    display: table;
    /* border: 1px solid #eee; */
    border-radius: 5px;
    background-color: white;
    width: max-content;
    min-width: 100%; /*  添加这行 */
    overflow-x: auto;
    border-collapse: collapse;
  
    /* table-layout: fixed; */ /*  可选， 如果需要表格平均布局 */
  }
  .table-container::-webkit-scrollbar {
    display: none;
  }
  .table-row {
    display: table-row;
  }
  
  .table-header-row {
    color: #888;
    font-size: 12px;
    line-height: 22px;
    height: 42px;
  }
  
  .table-total-row {
    font-weight: bold;
  }
  
  .table-cell {
    display: table-cell;
    min-width: 60px;
    padding: 10px;
    text-align: center;
    box-sizing: border-box;
    /* color: #212121; */
    font-size: 13px;
    vertical-align: middle;
  }
  .br-1 {
    border-right: 1px solid #ebeef5;
  }
  .head-bg {
    background: #f7f7f7;
  }
  /* .collapse-box {
    height: calc(100% - 105px);
    position: absolute;
    top: 53px;
    left: -6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    .collapse-icon {
      z-index: 1;
    }
    &::before {
      content: "";
      position: absolute;
      width: 1px;
      background: #f6f6f6;
      height: 100%;
      left: 50%;
      top: 0;
      z-index: 0;
    }
  } */
  .fixed-shadow {
    box-shadow: 4px 0px 6px 0px #00000008;
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right !important;
  }
  .text-left {
    text-align: left !important;
  }
  .table-border {
    border: 1px solid #ebeef5;
  }
  .borderClass {
    border-bottom: 1px solid #ebeef5;
  }
  .table-border-right {
    border-right: 1px solid #ebeef5;
  }
  .table-body-wrapper {
    overflow-y: auto;
  }
  .table-body-wrapper::-webkit-scrollbar {
    display: none;
  }
  .table-body-wrapper-fixed {
    overflow-y: auto;
  }
  .table-body-wrapper-fixed::-webkit-scrollbar {
    display: none;
  }
  .table-head-wrapper {
    overflow-x: auto;
  }
  .table-head-wrapper::-webkit-scrollbar {
    display: none;
  }
  </style>
  